/**
 * hero-slider.js — slider banner ở hero trang chủ.
 *
 * Markup đầu vào chỉ cần track + các slide:
 *   [data-slider] > ul[data-slider-track] > li.hero-slider__slide
 * Mũi tên, chấm tròn và nút tạm dừng do script này chèn — template WordPress
 * chỉ việc lặp qua slide, không phải in phần điều khiển.
 *
 * Chuyển slide bằng cuộn ngang + scroll-snap (CSS), nên vuốt trên cảm ứng và
 * cuộn bằng trackpad chạy sẵn của trình duyệt; JS chỉ gọi scrollTo. Khi JS lỗi
 * người dùng vẫn vuốt xem được đủ banner.
 *
 * Tự chạy 6s/slide, dừng khi rê chuột / focus / tab ẩn / bấm nút tạm dừng
 * (WCAG 2.2.2) và không tự chạy nếu hệ điều hành bật giảm chuyển động.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var INTERVAL = 6000;

    var root = document.querySelector('[data-slider]');
    if (!root) return;

    var track = root.querySelector('[data-slider-track]');
    if (!track) return;

    var slides = [].slice.call(track.children);
    if (slides.length < 2) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var index = 0;
    var timer = null;
    var pausedByUser = false;

    // ----- Nhãn cho trình đọc màn hình -----
    root.setAttribute('role', 'group');
    slides.forEach(function (slide, i) {
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-roledescription', 'slide');
        slide.setAttribute('aria-label', i + 1 + ' of ' + slides.length);
    });

    // ----- Điều khiển -----
    function makeButton(className, label, icon) {
        var button = document.createElement('button');
        button.className = className;
        button.type = 'button';
        button.setAttribute('aria-label', label);
        button.innerHTML = '<i class="ph ' + icon + '" aria-hidden="true"></i>';
        return button;
    }

    var prev = makeButton('hero-slider__nav hero-slider__nav--prev', 'Previous banner', 'ph-caret-left');
    var next = makeButton('hero-slider__nav hero-slider__nav--next', 'Next banner', 'ph-caret-right');
    var dots = document.createElement('div');
    dots.className = 'hero-slider__dots';

    var dotButtons = slides.map(function (slide, i) {
        var dot = document.createElement('button');
        dot.className = 'hero-slider__dot';
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Go to banner ' + (i + 1));
        dot.addEventListener('click', function () {
            goTo(i);
            stop(true);
        });
        dots.appendChild(dot);
        return dot;
    });

    var pause = makeButton('hero-slider__pause', 'Pause banner rotation', 'ph-pause');
    if (!reduced) dots.appendChild(pause);

    root.appendChild(prev);
    root.appendChild(next);
    root.appendChild(dots);

    // ----- Di chuyển -----
    function goTo(i) {
        index = (i + slides.length) % slides.length;
        var left = index * track.clientWidth;

        if (track.scrollTo) {
            track.scrollTo({ left: left, behavior: reduced ? 'auto' : 'smooth' });
        } else {
            track.scrollLeft = left;
        }
    }

    function sync() {
        var current = Math.round(track.scrollLeft / track.clientWidth);
        if (current === index) return;
        index = current;
        update();
    }

    function renderPause() {
        var running = !!timer;
        pause.setAttribute('aria-label', running ? 'Pause banner rotation' : 'Resume banner rotation');
        pause.innerHTML = '<i class="ph ' + (running ? 'ph-pause' : 'ph-play') + '" aria-hidden="true"></i>';
    }

    function update() {
        dotButtons.forEach(function (dot, i) {
            dot.classList.toggle('is-active', i === index);
            // aria-current thay cho aria-selected: đây là nút điều hướng, không phải tab
            if (i === index) {
                dot.setAttribute('aria-current', 'true');
            } else {
                dot.removeAttribute('aria-current');
            }
        });
    }

    prev.addEventListener('click', function () {
        goTo(index - 1);
        stop(true);
    });

    next.addEventListener('click', function () {
        goTo(index + 1);
        stop(true);
    });

    var ticking = false;
    track.addEventListener(
        'scroll',
        function () {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(function () {
                sync();
                ticking = false;
            });
        },
        { passive: true }
    );

    // ----- Tự chạy -----
    function start() {
        if (reduced || pausedByUser || timer) return;
        timer = window.setInterval(function () {
            goTo(index + 1);
        }, INTERVAL);
        track.setAttribute('aria-live', 'off');
        renderPause();
    }

    function stop(byUser) {
        if (byUser) pausedByUser = true;
        window.clearInterval(timer);
        timer = null;
        track.setAttribute('aria-live', 'polite');
        renderPause();
    }

    // Bấm mũi tên / chấm tròn là dừng hẳn tự chạy; nút này để bật lại
    pause.addEventListener('click', function () {
        if (timer) {
            stop(true);
        } else {
            pausedByUser = false;
            start();
        }
    });

    // Rê chuột / tab vào thì dừng tạm, rời ra chạy tiếp (trừ khi người dùng đã bấm dừng)
    root.addEventListener('mouseenter', function () {
        if (timer) stop(false);
    });
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', function () {
        if (timer) stop(false);
    });
    root.addEventListener('focusout', function (event) {
        if (!root.contains(event.relatedTarget)) start();
    });

    document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
            stop(false);
        } else {
            start();
        }
    });

    // Đổi khổ màn hình: chiều rộng slide đổi theo, canh lại cho đúng slide đang xem
    var resizeTimer;
    window.addEventListener('resize', function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(function () {
            track.scrollLeft = index * track.clientWidth;
        }, 150);
    });

    update();
    start();
})();
